import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import posthogLib from 'posthog-js';

import { symbolKey } from '@/entities/symbol';
import { closeDrawer } from '@/slices/drawerSlice';

import {
  addSymbol,
  addSymbols,
  restoreSymbols,
  setSymbols,
  toggleSymbol
} from './symbolSelector.slice';

export const selectionListener = createListenerMiddleware();

selectionListener.startListening({
  matcher: isAnyOf(addSymbol, addSymbols, setSymbols, toggleSymbol),
  effect: (action, api) => {
    const prev = (api.getOriginalState() as any).symbolSelector;
    const next = (api.getState() as any).symbolSelector;
    const isForwardMode = next.isForwardMode;

    const prevKeys = new Set<string>(prev.symbols.map((s: any) => symbolKey(s, isForwardMode)));
    const added = (next.symbols as any[]).filter(s => !prevKeys.has(symbolKey(s, isForwardMode)));
    if (added.length) {
      // Defer analytics to avoid blocking the UI thread during interactions
      const schedule = (fn: () => void) => {
        if (typeof globalThis !== 'undefined' && 'requestIdleCallback' in globalThis) {
          (globalThis as any).requestIdleCallback(() => {
            fn();
          });
        } else {
          setTimeout(fn, 0);
        }
      };
      schedule(() => {
        for (const symbol of added) {
          try {
            posthogLib.capture('symbol_select', { symbol });
          } catch {
            // non-fatal
          }
        }
      });
    }
  }
});

selectionListener.startListening({
  actionCreator: closeDrawer,
  effect: (_action, api) => {
    const { previousSymbols } = (api.getState() as any).symbolSelector;
    if (previousSymbols !== null) {
      api.dispatch(restoreSymbols());
    }
  }
});
